export var ImageCacheStatus;
(function (ImageCacheStatus) {
    ImageCacheStatus[ImageCacheStatus["NOT_CACHED"] = 1] = "NOT_CACHED";
    ImageCacheStatus[ImageCacheStatus["CACHING"] = 2] = "CACHING";
    ImageCacheStatus[ImageCacheStatus["CACHED"] = 3] = "CACHED";
    ImageCacheStatus[ImageCacheStatus["FAILED"] = 4] = "FAILED";
})(ImageCacheStatus || (ImageCacheStatus = {}));
